import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './ClientInvestments.module.css'
import Modal from '../../components/Modal/Modal'
import { prpHttpAPI } from '../../services/prpHttpAPI'
import PageTracker from '../../components/PageTracker/PageTracker'
export const ClientInvestments = () => {
  const navigate = useNavigate()
  const plan_id = localStorage.getItem('plan_id');    //updatedd
  // token authentication 
  const checkToken = (e) => {

    const localtoken = localStorage.getItem("ssotoken");
    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const ssotoken = queryParams.get('ssotoken');
    if (localtoken) {
      console.log('User logged in');
    }
    else {
      console.log('token not found');
      // Redirect to a different URL
      window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;

      //  navigate('');
    }
  }
  useEffect(() => {
    checkToken();
  }, [])
  const [loading, setLoading] = useState(false);
  const [epfHolding, setEpfHolding] = useState("")
  const [numericEpfHolding, setNumericEpfHolding] = useState(null);
  const [epfContribution, setEpfContribution] = useState("")
  const [numericEpfContribution, setNumericEpfContribution] = useState(null)
  const [npsHolding, setNpsHolding] = useState("")
  const [numericNpsHolding, setNumericNpsHolding] = useState(null)
  const [npsContribution, setNpsContribution] = useState("")
  const [numericNpsContribution, setNumericNpsContribution] = useState(null)
  const [mfHolding, setMfHolding] = useState("")
  const [numericMfHolding, setNumericMfHolding] = useState(null)

  const [mfContribution, setMfContribution] = useState("")
  const [numericMfContribution, setNumericMfContribution] = useState(null)
  const [bondsHolding, setBondsHolding] = useState("")
  const [numericBondsHolding, setNumericBondsHolding] = useState(null)

  const [bondsContribution, setBondsContribution] = useState("0")
  const [numericBondsContribution, setNumericBondsContribution] = useState(null)

  const [nonRetHolding, setNonRetHolding] = useState("")
  const [numericNonRetHolding, setNumericNonRetHolding] = useState(null)

  const [nonRetContribution, setNonRetContribution] = useState("")
  const [numericNonRetContribution, setNumericNonRetContribution] = useState(null)

  const [ppfHolding, setPpfHolding] = useState("")
  const [numericPpfHolding, setNumericPpfHolding] = useState(null)

  const [ppfContribution, setPpfContribution] = useState("")
  const [numericPpfContribution, setNumericPpfContribution] = useState(null)

  const [retHolding, setRetHolding] = useState("")
  const [numericRetHolding, setNumericRetHolding] = useState(null)

  const [retContribution, setRetContribution] = useState("")
  const [numericRetContribution, setNumericRetContribution] = useState(null)

  const [stocksHolding, setStocksHolding] = useState("")
  const [numericStocksHolding, setNumericStocksHolding] = useState(null)

  const [stocksContribution, setStocksContribution] = useState("0")
  const [numericStocksContribution, setNumericStocksContribution] = useState(null)

  const [fdHolding, setFdHolding] = useState("")
  const [numericFdHolding, setNumericFdHolding] = useState(null)

  const [fdContribution, setFdContribution] = useState("")
  const [numericFdContribution, setNumericFdContribution] = useState(null)
  const [vpfHolding, setVpfHolding] = useState("")                                //updatedd
  const [numericVpfHolding, setNumericVpfHolding] = useState(null)                //updatedd
  const [vpfContribution, setVpfContribution] = useState("")                     //updatedd
  const [numericVpfContribution, setNumericVpfContribution] = useState(null)      //updatedd
  const [capitalReceipts, setCapitalReceipts] = useState([])                        //updatedd
  const [annualIncrease, setAnnualIncrease] = useState("0")                        //updatedd
  const [annualIncreaseCap, setAnnualIncreaseCap] = useState(15)                   //updatedd
  const [retirementLabels, setRetirementLabels] = useState(["EPF", "PPF", "VPF", "NPS", "Other Ret."])            //updatedd
  const [liquidLabels, setLiquidLabels] = useState(["Mutual Funds", "Stocks", "Bonds", "FD / RD", "Other Non Ret."])  //updatedd
  const [visibleRetirementRows, setVisibleRetirementRows] = useState([0, 1, 2, 3, 4])              //updatedd
  const [visibleLiquidRows, setVisibleLiquidRows] = useState([0, 1, 2, 3, 4])                     //updatedd
  const [retirementReturns, setRetirementReturns] = useState([8.25, 7.1, 8.25, 10.0, 8.0]);         //updatedd
  const [npsInfoOpen, setNpsInfoOpen] = useState(false);
  const [liquidReturns, setLiquidReturns] = useState([12.0, 12.0, 8.0, 7.0, 10.0]);                  //updatedd
  const [totalRetirementHolding, setTotalRetirementHolding] = useState("");                     //updatedd
  const [totalRetirementMonthly, setTotalRetirementMonthly] = useState("");                     //updatedd
  const [totalLiquidHolding, setTotalLiquidHolding] = useState("");                             //updatedd
  const [totalLiquidMonthly, setTotalLiquidMonthly] = useState("");                             //updatedd
  const [retirementWeightedReturn, setRetirementWeightedReturn] = useState(8.0);
  const [liquidWeightedReturn, setLiquidWeightedReturn] = useState(9.8);                            //updatedd
  const [totalHolding, setTotalHolding] = useState("")
  const [totalContribution, setTotalContribution] = useState("")
  const [progressValuePre, setProgressValuePre] = useState(6);
  const [progressValuePost, setProgressValuePost] = useState(4);           //updatedd
  const [showModal, setShowModal] = useState(false)
  const [showSavedMessage, setShowSavedMessage] = useState(false)
  const [annualIncreaseError, setAnnualIncreaseError] = useState('')
  const [url, setUrl] = useState('');                                       //updatedd
  const [data, setData] = useState({});                                     //updatedd
  const [downloadFlag, setDownloadFlag] = useState(false);                  //updatedd
  const [inflationRateClientDetails, setInflationRateClientDetails] = useState(0);   //updatedd

  //onRefreshOnly
  useEffect(() => {
    const handleRefresh = () => {
      localStorage.removeItem('clientInvestmentData');

    };

    window.addEventListener('beforeunload', handleRefresh);

    return () => {
      window.removeEventListener('beforeunload', handleRefresh);
    };
  }, []);
  //toRetainClientDetails - on clicking back button in clientInvestments
  useEffect(() => {
    // Load inflation rate from ClientDetails (localStorage) first, so it is always initialized
    const savedUserData = localStorage.getItem('userData');
    let infRateVal = 6;
    if (savedUserData) {
      try {
        const parsed = JSON.parse(savedUserData);
        if (parsed.inflation_rate != null) {
          infRateVal = parseFloat(String(parsed.inflation_rate)) || 6;
        }
      } catch (e) {
        console.error("Error reading inflation_rate from userData:", e);
      }
    } else {
      const savedInflation = localStorage.getItem('inflationRate');
      if (savedInflation) {
        infRateVal = parseFloat(savedInflation) || 6;
      }
    }
    setInflationRateClientDetails(infRateVal);

    const savedData = localStorage.getItem('clientInvestmentData');
    if (savedData) {
      const userData = JSON.parse(savedData);
      setEpfHolding(numToString(userData.epf_holding));
      setNumericEpfHolding(userData.epf_holding)
      setEpfContribution(numToString(userData.epf_monthly));
      setNumericEpfContribution(userData.epf_monthly)

      setPpfHolding(numToString(userData.ppf_holding))
      setPpfContribution(numToString(userData.ppf_monthly))
      setNpsHolding(numToString(userData.nps_holding))
      setNpsContribution(numToString(userData.nps_monthly))
      setRetHolding(numToString(userData.other_retirement_investment_holding))
      setRetContribution(numToString(userData.other_retirement_investment_monthly));
      setNonRetHolding(numToString(userData.other_non_retirement_investment_holding))
      setNonRetContribution(numToString(userData.other_non_retirement_investment_monthly))
      setMfHolding(numToString(userData.mf_holding))
      setMfContribution(numToString(userData.mf_monthly))
      setStocksHolding(numToString(userData.stocks_holding))
      setStocksContribution(numToString(userData.stocks_monthly))
      setBondsHolding(numToString(userData.bonds_holding))
      setBondsContribution(numToString(userData.bonds_monthly))
      setFdHolding(numToString(userData.fdrd_holding))
      setFdContribution(numToString(userData.fdrd_monthly))
      setVpfHolding(numToString(userData.vpf_holding))          //updatedd
      setVpfContribution(numToString(userData.vpf_monthly))     //updatedd
      setNumericVpfHolding(userData.vpf_holding)               //updatedd
      setNumericVpfContribution(userData.vpf_monthly)           //updatedd
      const resolvedReceipts = (userData.capital_receipts || []).map(r => ({
        CRName: r.CRName || r.description || '',
        CRYear: r.CRYear || r.year || '',
        CRAmt: r.CRAmt || r.amount ? new Intl.NumberFormat('en-IN').format(Number(String(r.CRAmt || r.amount || '').replace(/,/g, ''))) : ''
      }));
      setCapitalReceipts(resolvedReceipts);
      setAnnualIncrease(String(userData.annual_increase ?? "0"))       //updatedd
      if (userData.return_percent) {
        let rp = userData.return_percent;
        if (typeof rp === 'string') {
          try { rp = JSON.parse(rp); } catch (e) { }
        }
        if (Array.isArray(rp)) {
          const retArr = [8.25, 7.1, 8.25, 10.0, 8.0];
          const liqArr = [12.0, 12.0, 8.0, 7.0, 10.0];
          rp.forEach(item => {
            if (item.asset === "epf") retArr[0] = item.return_percent;
            if (item.asset === "ppf") retArr[1] = item.return_percent;
            if (item.asset === "vpf") retArr[2] = item.return_percent;
            if (item.asset === "nps") retArr[3] = item.return_percent;
            if (item.asset === "other_retirement") retArr[4] = item.return_percent;
            if (item.asset === "mf") liqArr[0] = item.return_percent;
            if (item.asset === "stocks") liqArr[1] = item.return_percent;
            if (item.asset === "bonds") liqArr[2] = item.return_percent;
            if (item.asset === "fdrd") liqArr[3] = item.return_percent;
            if (item.asset === "other_liquid") liqArr[4] = item.return_percent;
          });
          setRetirementReturns(retArr);
          setLiquidReturns(liqArr);
        } else if (rp && typeof rp === 'object') {
          if (rp.retirement) setRetirementReturns(rp.retirement);
          if (rp.liquid) setLiquidReturns(rp.liquid);
        }
      } else {
        if (userData.retirement_returns) setRetirementReturns(userData.retirement_returns);
        if (userData.liquid_returns) setLiquidReturns(userData.liquid_returns);
      }



      //
      setNumericPpfHolding((userData.ppf_holding))
      setNumericPpfContribution((userData.ppf_monthly))
      setNumericNpsHolding((userData.nps_holding))
      setNumericNpsContribution((userData.nps_monthly))
      setNumericRetHolding((userData.other_retirement_investment_holding))
      setNumericRetContribution((userData.other_retirement_investment_monthly));
      setNumericNonRetHolding((userData.other_non_retirement_investment_holding))
      setNumericNonRetContribution((userData.other_non_retirement_investment_monthly))
      setNumericMfHolding((userData.mf_holding))
      setNumericMfContribution((userData.mf_monthly))
      setNumericStocksHolding((userData.stocks_holding))
      setNumericStocksContribution((userData.stocks_monthly))
      setNumericBondsHolding((userData.bonds_holding))
      setNumericBondsContribution((userData.bonds_monthly))
      setNumericFdHolding((userData.fdrd_holding))
      setNumericFdContribution((userData.fdrd_monthly))
      //
      setProgressValuePre((userData.pre_ret_ror))
      setProgressValuePost((userData.post_ret_ror))
      console.log("total,", userData.total_holding);
      setTotalHolding(numToString(userData.total_holding))
      setTotalContribution(numToString(userData.total_monthly))
      console.log("totalll", totalHolding);

    }
  }, []);
  //function to convert comma separated to numeric
  const stringToNum = (val) => {
    if (val === null || val === undefined) return 0;
    if (typeof val === "number") return val;
    let inputValue = String(val).replace(/,/g, "");
    return Number(inputValue) || 0;
  }
  //function to convert num to string 
  const numToString = (val) => {
    if (!val || isNaN(val) || val == 0) {
      return ""
    }
    return Intl.NumberFormat("en-IN").format(val)
  }
  //fetching version from plan_id
  const processString = (str) => {
    if (str.length === 10) {
      return 1;
    } else if (str.length > 10) {
      const parts = str.split('_');
      return parts.length > 1 ? Number(parts[1]) : null; // Return the number after '_', if present
    }
    return null; // Handle cases where string length is less than 10
  };
  // disable scrolling when modal is visible
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }

    return () => {
      document.body.style.overflow = "auto"; // Cleanup in case of component unmount
    };
  }, [showModal]);
  //totalHolding
  useEffect(() => {
    const totalHold = Number(numericEpfHolding || 0) + Number(numericNpsHolding || 0) + Number(numericMfHolding || 0) + Number(numericPpfHolding || 0) + Number(numericFdHolding || 0) + Number(numericRetHolding || 0) + Number(numericNonRetHolding || 0) + Number(numericBondsHolding || 0) + Number(numericStocksHolding || 0) + Number(numericVpfHolding || 0);
    setTotalHolding(Intl.NumberFormat("en-IN").format(totalHold));
  }, [numericEpfHolding, numericNpsHolding, numericMfHolding, numericPpfHolding, numericFdHolding, numericRetHolding, numericNonRetHolding, numericBondsHolding, numericStocksHolding, numericVpfHolding])
  //totalContribution
  useEffect(() => {
    const total = Number(numericEpfContribution || 0) + Number(numericNpsContribution || 0) + Number(numericMfContribution || 0) + Number(numericPpfContribution || 0) + Number(numericFdContribution || 0) + Number(numericRetContribution || 0) + Number(numericNonRetContribution || 0) + Number(numericBondsContribution || 0) + Number(numericStocksContribution || 0) + Number(numericVpfContribution || 0);           //updatedd
    setTotalContribution(Intl.NumberFormat("en-IN").format(total));
  }, [numericEpfContribution, numericNpsContribution, numericMfContribution, numericPpfContribution, numericFdContribution, numericRetContribution, numericNonRetContribution, numericBondsContribution, numericStocksContribution, numericVpfContribution])  //updatedd

  //totalRetirementHolding & Monthly
  useEffect(() => {
    const totalH = Number(numericEpfHolding || 0) + Number(numericPpfHolding || 0) + Number(numericVpfHolding || 0) + Number(numericNpsHolding || 0) + Number(numericRetHolding || 0);
    setTotalRetirementHolding(Intl.NumberFormat("en-IN").format(totalH));

    const totalM = Number(numericEpfContribution || 0) + Number(numericPpfContribution || 0) + Number(numericVpfContribution || 0) + Number(numericNpsContribution || 0) + Number(numericRetContribution || 0);
    setTotalRetirementMonthly(Intl.NumberFormat("en-IN").format(totalM));
  }, [numericEpfHolding, numericPpfHolding, numericVpfHolding, numericNpsHolding, numericRetHolding, numericEpfContribution, numericPpfContribution, numericVpfContribution, numericNpsContribution, numericRetContribution])

  //totalLiquidHolding & Monthly
  useEffect(() => {
    const totalH = Number(numericMfHolding || 0) + Number(numericStocksHolding || 0) + Number(numericBondsHolding || 0) + Number(numericFdHolding || 0) + Number(numericNonRetHolding || 0);
    setTotalLiquidHolding(Intl.NumberFormat("en-IN").format(totalH));

    const totalM = Number(numericMfContribution || 0) + Number(numericStocksContribution || 0) + Number(numericBondsContribution || 0) + Number(numericFdContribution || 0) + Number(numericNonRetContribution || 0);
    setTotalLiquidMonthly(Intl.NumberFormat("en-IN").format(totalM));
  }, [numericMfHolding, numericStocksHolding, numericBondsHolding, numericFdHolding, numericNonRetHolding, numericMfContribution, numericStocksContribution, numericBondsContribution, numericFdContribution, numericNonRetContribution])

  // Calculate weighted Return Rates (Retirement, Liquid, and Overall Combined)
  useEffect(() => {
    // 1. Retirement Weighted Return
    const retAssets = [
      { holding: Number(numericEpfHolding || 0), ror: parseFloat(retirementReturns[0] || 0) },
      { holding: Number(numericPpfHolding || 0), ror: parseFloat(retirementReturns[1] || 0) },
      { holding: Number(numericVpfHolding || 0), ror: parseFloat(retirementReturns[2] || 0) },
      { holding: Number(numericNpsHolding || 0), ror: parseFloat(retirementReturns[3] || 0) },
      { holding: Number(numericRetHolding || 0), ror: parseFloat(retirementReturns[4] || 0) },
    ];
    let retHoldingVal = 0;
    let retWeightedSum = 0;
    retAssets.forEach(asset => {
      if (asset.holding > 0) {
        retHoldingVal += asset.holding;
        retWeightedSum += asset.holding * asset.ror;
      }
    });

    // 2. Liquid Weighted Return
    const liqAssets = [
      { holding: Number(numericMfHolding || 0), ror: parseFloat(liquidReturns[0] || 0) },
      { holding: Number(numericStocksHolding || 0), ror: parseFloat(liquidReturns[1] || 0) },
      { holding: Number(numericBondsHolding || 0), ror: parseFloat(liquidReturns[2] || 0) },
      { holding: Number(numericFdHolding || 0), ror: parseFloat(liquidReturns[3] || 0) },
      { holding: Number(numericNonRetHolding || 0), ror: parseFloat(liquidReturns[4] || 0) },
    ];
    let liqHoldingVal = 0;
    let liqWeightedSum = 0;
    liqAssets.forEach(asset => {
      if (asset.holding > 0) {
        liqHoldingVal += asset.holding;
        liqWeightedSum += asset.holding * asset.ror;
      }
    });

    // Compute separate weighted averages
    if (retHoldingVal > 0) {
      const calculatedRetRor = retWeightedSum / retHoldingVal;
      setRetirementWeightedReturn(Math.round(calculatedRetRor * 100) / 100);
    } else {
      setRetirementWeightedReturn(8.0);
    }

    if (liqHoldingVal > 0) {
      const calculatedLiqRor = liqWeightedSum / liqHoldingVal;
      setLiquidWeightedReturn(Math.round(calculatedLiqRor * 100) / 100);
    } else {
      setLiquidWeightedReturn(8.0);
    }

    // 3. Combined Overall Pre-Retirement Weighted Return (progressValuePre)
    const totalHoldingVal = retHoldingVal + liqHoldingVal;
    const totalWeightedSum = retWeightedSum + liqWeightedSum;

    if (totalHoldingVal > 0) {
      const calculatedOverallRor = totalWeightedSum / totalHoldingVal;
      const roundedOverallRor = Math.round(calculatedOverallRor * 100) / 100;
      setProgressValuePre(roundedOverallRor);
    } else {
      setProgressValuePre(8.0);
    }
  }, [
    numericEpfHolding, numericPpfHolding, numericVpfHolding, numericNpsHolding, numericRetHolding,
    numericMfHolding, numericStocksHolding, numericBondsHolding, numericFdHolding, numericNonRetHolding,
    retirementReturns, liquidReturns
  ]);

  // Calculate and enforce annualIncrease constraint:
  // - Must be 70% of Annual Income Growth Rate (loaded from ClientDetails.jsx)
  // - Must not exceed individual asset return rates or weighted average return rates
  useEffect(() => {
    let growthRate = 7; // Default fallback to Moderate (7%)
    const savedUserData = localStorage.getItem('userData');
    if (savedUserData) {
      try {
        const parsed = JSON.parse(savedUserData);
        if (parsed.annual_growth_rate !== undefined) {
          growthRate = Number(parsed.annual_growth_rate);
        }
      } catch (e) {
        console.error("Error reading annual_growth_rate from userData:", e);
      }
    }

    // Cap = min of:
    //   1. 70% of Annual Income Growth Rate
    //   2. Retirement Instruments weighted return
    //   3. Liquid Instruments weighted return
    const seventyPct = Math.floor(0.7 * growthRate);
    const calculatedCap = Math.max(
      0,
      Math.floor(Math.min(seventyPct, retirementWeightedReturn, liquidWeightedReturn))
    );
    setAnnualIncreaseCap(calculatedCap);

    // Clamp current value if it now exceeds the new cap; never auto-set from 0
    setAnnualIncrease(prev => {
      const parsedPrev = Number(prev) || 0;
      if (parsedPrev > calculatedCap) {
        return String(calculatedCap);
      }
      return prev;
    });
  }, [retirementWeightedReturn, liquidWeightedReturn]);

  const handleProgressPreChange = (event) => {
    const rawValue = event.target.value;
    // if(rawValue == "") return;
    let value = parseFloat(rawValue);


    const category = getInvestmentCategory();

    let cappedValue = value;

    if (category === "LOW_ONLY" && value > 8) {
      cappedValue = 8;
    } else if (category === "HIGH_ONLY" && value > 12) {
      cappedValue = 12;
    } else if (category === "MIXED" && value > 10) {
      cappedValue = 10;
    }
    else if (category === "NONE" && value > 15) {
      value = 15;
    }

    setProgressValuePre(cappedValue);

    // auto-adjust post-retirement
    if (cappedValue >= 0) {                                                 //updatedd
      const inflation = Number(inflationRateClientDetails) || 6;
      const targetPost = cappedValue - 2;
      if (targetPost < inflation || targetPost === inflation) {
        setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
      } else {
        setProgressValuePost(targetPost);
      }
    }
  };

  const handlePreInflationBlur = (event) => {
    let value = Math.round(event.target.value * 2) / 2;

    const category = getInvestmentCategory();

    if (category === "LOW_ONLY" && value > 8) value = 8;
    if (category === "HIGH_ONLY" && value > 12) value = 12;
    if (category === "MIXED" && value > 10) value = 10;

    if (category === "NONE" && value > 15) {
      value = 15;
    }

    if (value < 0) value = 0;                            //updatedd

    setProgressValuePre(value);
    const inflation = Number(inflationRateClientDetails) || 6;
    const targetPost = value - 2;
    if (targetPost < inflation || targetPost === inflation) {
      setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
    } else {
      setProgressValuePost(targetPost);
    }
  }
  const handleProgressPostChange = (event) => {
    let value = event.target.value;

    // Allow only numbers with up to 2 digits and an optional single decimal place
    const validPattern = /^(?:\d{1,2}(?:\.\d)?)?$/;

    if (validPattern.test(value)) {
      setProgressValuePost(parseFloat(value) || ""); // Ensure empty input doesn't become NaN
    }
  };
  const handlePostInflationBlur = (event) => {
    let value = parseFloat(event.target.value);
    if (isNaN(value)) {
      value = 0;
    }
    const inflation = Number(inflationRateClientDetails) || 6;

    if (value < inflation) {
      // Strictly less than inflation → alert and correct
      alert("Post-retirement rate should not be less than inflation rate");
      setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
    } else if (value === inflation) {
      // Exactly equal → silently bump to inflation + 0.001 (no alert)
      setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
    } else if (value > 10) {
      setProgressValuePost(10);
    } else {
      // Greater than inflation → round to nearest 0.5 (no decimal)
      const rounded = Math.round(value * 2) / 2;
      if (rounded < inflation) {
        // Rounding pushed it below inflation → alert
        alert("Post-retirement rate should not be less than inflation rate");
        setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
      } else if (rounded === inflation) {
        // Rounding landed exactly on inflation → silently bump
        setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
      } else if (rounded > 10) {
        setProgressValuePost(10);
      } else {
        setProgressValuePost(rounded);
      }
    }
  }
  //pdf download
  const donwloadPDF = async (url) => {
    //console.log('download pdf function called')
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank"
    link.download = `${plan_id}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    //console.log("pdfUrl", url);

  }
  //epf
  const handleEpfHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setEpfHolding("");
      setNumericEpfHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setEpfHolding(formattedValue);
    setNumericEpfHolding(numericValue);
  };
  const handleEpfContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setEpfContribution("");
      setNumericEpfContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setEpfContribution(formattedValue);
    setNumericEpfContribution(numericValue);

  }
  // nps
  const handleNpsHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNpsHolding("");
      setNumericNpsHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setNpsHolding(formattedValue);
    setNumericNpsHolding(numericValue);


  }
  const handleNpsContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNpsContribution("");
      setNumericNpsContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setNpsContribution(formattedValue);
    setNumericNpsContribution(numericValue);

  }
  // mf
  const handleMfHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setMfHolding("");
      setNumericMfHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setMfHolding(formattedValue);
    setNumericMfHolding(numericValue);


  }
  const handleMfContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setMfContribution("");
      setNumericMfContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setMfContribution(formattedValue);
    setNumericMfContribution(numericValue);

  }
  //bonds
  const handleBondsHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setBondsHolding("");
      setNumericBondsHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setBondsHolding(formattedValue);
    setNumericBondsHolding(numericValue);


  }
  const handleBondsContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setBondsContribution("");
      setNumericBondsContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setBondsContribution(formattedValue);
    setNumericBondsContribution(numericValue);

  }
  //nonRet
  const handleNonRetHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNonRetHolding("");
      setNumericNonRetHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setNonRetHolding(formattedValue);
    setNumericNonRetHolding(numericValue);


  }
  const handleNonRetContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setNonRetContribution("");
      setNumericNonRetContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setNonRetContribution(formattedValue);
    setNumericNonRetContribution(numericValue);

  }
  //ppf
  const handlePpfHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setPpfHolding("");
      setNumericPpfHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setPpfHolding(formattedValue);
    setNumericPpfHolding(numericValue);


  }
  const handlePpfContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setPpfContribution("");
      setNumericPpfContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setPpfContribution(formattedValue);
    setNumericPpfContribution(numericValue);

  }

  //ret
  const handleRetHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setRetHolding("");
      setNumericRetHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setRetHolding(formattedValue);
    setNumericRetHolding(numericValue);


  }
  const handleRetContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setRetContribution("");
      setNumericRetContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setRetContribution(formattedValue);
    setNumericRetContribution(numericValue);

  }
  //stocks
  const handleStocksHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setStocksHolding("");
      setNumericStocksHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setStocksHolding(formattedValue);
    setNumericStocksHolding(numericValue);


  }
  const handleStocksContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setStocksContribution("");
      setNumericStocksContribution(null);
    }

    // Prevent leading zero
    // if (inputValue.length > 1 && inputValue[0] === "0") {
    //   return;
    // }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setStocksContribution(formattedValue);
    setNumericStocksContribution(numericValue);

  }
  //fd
  const handleFdHolding = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setFdHolding("");
      setNumericFdHolding(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setFdHolding(formattedValue);
    setNumericFdHolding(numericValue);


  }
  const handleFdContribution = (event) => {
    let inputValue = event.target.value.replace(/,/g, "");
    // Allow empty input for backspacing
    if (inputValue === "") {
      setFdContribution("");
      setNumericFdContribution(null);
    }

    // Prevent leading zero
    if (inputValue.length > 1 && inputValue[0] === "0") {
      return;
    }

    // Allow only numeric input
    if (!/^[1-9][0-9]*$/.test(inputValue)) {
      return; // Stop execution if input is not a number or starts with 0
    }

    // Restrict maximum value to 10 crores (100000000)
    if (Number(inputValue) > 1000000000) {
      return;
    }

    const numericValue = Number(inputValue);
    const formattedValue = new Intl.NumberFormat("en-IN").format(numericValue);

    // Set both formatted and numeric values
    setFdContribution(formattedValue);
    setNumericFdContribution(numericValue);

  }

  const handleVpfHolding = (event) => {                                   //updatedd 
    let inputValue = event.target.value.replace(/,/g, "");
    if (inputValue === "") {
      setVpfHolding("");
      setNumericVpfHolding(null);
    }
    if (inputValue.length > 1 && inputValue[0] === "0") return;
    if (!/^[1-9][0-9]*$/.test(inputValue)) return;
    if (Number(inputValue) > 1000000000) return;
    const numericValue = Number(inputValue);
    setVpfHolding(new Intl.NumberFormat("en-IN").format(numericValue));
    setNumericVpfHolding(numericValue);
  };

  const handleVpfContribution = (event) => {                               //updatedd
    let inputValue = event.target.value.replace(/,/g, "");
    if (inputValue === "") {
      setVpfContribution("");
      setNumericVpfContribution(null);
    }
    if (inputValue.length > 1 && inputValue[0] === "0") return;
    if (!/^[1-9][0-9]*$/.test(inputValue)) return;
    if (Number(inputValue) > 1000000000) return;
    const numericValue = Number(inputValue);
    setVpfContribution(new Intl.NumberFormat("en-IN").format(numericValue));
    setNumericVpfContribution(numericValue);
  };

  const addCapitalReceipt = () => {                                                           //updatedd
    setCapitalReceipts([...capitalReceipts, { CRName: "", CRYear: "", CRAmt: "" }]);
    setShowSavedMessage(false);
  };

  const removeCapitalReceipt = (index) => {                                           //updatedd
    setCapitalReceipts(capitalReceipts.filter((_, i) => i !== index));
    setShowSavedMessage(false);
  };

  const updateCapitalReceipt = (index, field, value) => {                      //updatedd
    const updated = [...capitalReceipts];
    if (field === 'CRAmt') {
      const raw = value.replace(/,/g, '');
      if (raw === '') {
        updated[index][field] = '';
      } else if (/^[0-9]+$/.test(raw) && Number(raw) <= 1000000000) {
        updated[index][field] = new Intl.NumberFormat('en-IN').format(Number(raw));
      }
      // else: ignore invalid input
    } else {
      updated[index][field] = value;
    }
    setCapitalReceipts(updated);
    setShowSavedMessage(false);
  };

  const handleSaveCapitalReceipts = () => {
    const savedData = localStorage.getItem('clientInvestmentData');
    let userData = {};
    if (savedData) {
      userData = JSON.parse(savedData);
    }
    userData.capital_receipts = capitalReceipts.map(r => ({
      description: r.CRName,
      year: r.CRYear,
      amount: Number(String(r.CRAmt || '').replace(/,/g, '')) || 0,
      CRName: r.CRName,
      CRYear: r.CRYear,
      CRAmt: r.CRAmt
    }));
    localStorage.setItem('clientInvestmentData', JSON.stringify(userData));
    setShowSavedMessage(true);
  };

  const updateRetirementLabel = (index, value) => {                   //updatedd
    const updated = [...retirementLabels];
    updated[index] = value;
    setRetirementLabels(updated);
  };

  const updateLiquidLabel = (index, value) => {                           //updatedd
    const updated = [...liquidLabels];
    updated[index] = value;
    setLiquidLabels(updated);
  };

  const updateRetirementReturn = (index, value) => {
    const updated = [...retirementReturns];
    updated[index] = value;
    setRetirementReturns(updated);
  };

  const updateLiquidReturn = (index, value) => {
    const updated = [...liquidReturns];
    updated[index] = value;
    setLiquidReturns(updated);
  };

  const clearRetirementRow = (idx) => {                                                         //updatedd
    const setters = [
      [setEpfHolding, setEpfContribution, setNumericEpfHolding, setNumericEpfContribution],
      [setPpfHolding, setPpfContribution, setNumericPpfHolding, setNumericPpfContribution],
      [setVpfHolding, setVpfContribution, setNumericVpfHolding, setNumericVpfContribution],
      [setNpsHolding, setNpsContribution, setNumericNpsHolding, setNumericNpsContribution],
      [setRetHolding, setRetContribution, setNumericRetHolding, setNumericRetContribution],
    ];
    if (setters[idx]) {
      const [setHold, setCont, setNumHold, setNumCont] = setters[idx];
      setHold("");
      setCont("");
      setNumHold(null);
      setNumCont(null);
    }
  };

  const clearLiquidRow = (idx) => {                                                      //updatedd
    const setters = [
      [setMfHolding, setMfContribution, setNumericMfHolding, setNumericMfContribution],
      [setStocksHolding, setStocksContribution, setNumericStocksHolding, setNumericStocksContribution],
      [setBondsHolding, setBondsContribution, setNumericBondsHolding, setNumericBondsContribution],
      [setFdHolding, setFdContribution, setNumericFdHolding, setNumericFdContribution],
      [setNonRetHolding, setNonRetContribution, setNumericNonRetHolding, setNumericNonRetContribution],
    ];
    if (setters[idx]) {
      const [setHold, setCont, setNumHold, setNumCont] = setters[idx];
      setHold("");
      setCont("");
      setNumHold(null);
      setNumCont(null);
    }
  };

  const removeRetirementRow = (idx) => {                                      //updatedd
    clearRetirementRow(idx);
    setVisibleRetirementRows(visibleRetirementRows.filter(i => i !== idx));
  };

  const removeLiquidRow = (idx) => {                                   //updatedd
    clearLiquidRow(idx);
    setVisibleLiquidRows(visibleLiquidRows.filter(i => i !== idx));
  };

  const addRetirementRow = () => {                                      //updatedd
    const nextIdx = retirementLabels.length;
    setRetirementLabels([...retirementLabels, "New Item"]);
    setRetirementReturns([...retirementReturns, 8.0]);
    setVisibleRetirementRows([...visibleRetirementRows, nextIdx]);
  };

  const addLiquidRow = () => {                                      //updatedd
    const nextIdx = liquidLabels.length;
    setLiquidLabels([...liquidLabels, "New Item"]);
    setLiquidReturns([...liquidReturns, 8.0]);
    setVisibleLiquidRows([...visibleLiquidRows, nextIdx]);
  };



  const pdfData = data;    //updatedd — used for PDF generation

  const getPdfURL = async () => {
    let returnObj = null;
    try {
      setShowModal(true);
      const result = await prpHttpAPI(pdfData, 'get-pdf/pdf', null, "POST")
      if (result.success) {
        returnObj = result;
        setUrl(result.url)

      }
    } catch (error) {
      console.log("There is some error after api fetch", error.message);
    }

    return returnObj

  }

  const handlePreparePlan = async () => {
    if (Number(annualIncrease) > annualIncreaseCap) {
      alert(`Max allowed: ${annualIncreaseCap}% (= min of 70% of income growth rate, Retirement Return & Liquid Return)`);
      return;
    }

    const postRetRorVal = Number(progressValuePost) || 0;
    const inflation = Number(inflationRateClientDetails) || 6;
    if (postRetRorVal < inflation) {
      alert("Post-retirement rate should not be less than inflation rate");
      setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
      return;
    }

    let resolvedPostRetRor = postRetRorVal;
    if (postRetRorVal === inflation) {
      resolvedPostRetRor = inflation;
      setProgressValuePost(resolvedPostRetRor);
    }

    // Create the data you want to encrypt
    // if (!validatePreRetirementReturn()) return;
    try {
      setLoading(true);

      const savedData = localStorage.getItem('clientInvestmentData');
      let existingGoals = [];
      let existingInsurance = [];
      let existingLiabilities = [];
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);
          existingGoals = parsed.goals || [];
          existingInsurance = parsed.insurance_coverage || [];
          existingLiabilities = parsed.liabilities_loans || [];
        } catch (e) {
          console.error("Error parsing existing goals", e);
        }
      }

      const userData = {
        plan_id: plan_id,
        epf_holding: stringToNum(epfHolding),
        epf_monthly: stringToNum(epfContribution),
        vpf_holding: stringToNum(vpfHolding),                   //updatedd
        vpf_monthly: stringToNum(vpfContribution),               //updatedd
        ppf_holding: stringToNum(ppfHolding),
        ppf_monthly: stringToNum(ppfContribution),
        nps_holding: stringToNum(npsHolding),
        nps_monthly: stringToNum(npsContribution),
        other_retirement_investment_holding: stringToNum(retHolding),
        other_retirement_investment_monthly: stringToNum(retContribution),
        mf_holding: stringToNum(mfHolding),
        mf_monthly: stringToNum(mfContribution),
        stocks_holding: stringToNum(stocksHolding),
        stocks_monthly: stringToNum(stocksContribution),
        bonds_holding: stringToNum(bondsHolding),
        bonds_monthly: stringToNum(bondsContribution),
        fdrd_holding: stringToNum(fdHolding),
        fdrd_monthly: stringToNum(fdContribution),
        other_non_retirement_investment_holding: stringToNum(nonRetHolding),
        other_non_retirement_investment_monthly: stringToNum(nonRetContribution),
        post_ret_ror: resolvedPostRetRor,
        pre_ret_ror: (progressValuePre),
        return_percent: [
          { asset: "epf", return_percent: parseFloat(retirementReturns[0]) || 0 },
          { asset: "ppf", return_percent: parseFloat(retirementReturns[1]) || 0 },
          { asset: "vpf", return_percent: parseFloat(retirementReturns[2]) || 0 },
          { asset: "nps", return_percent: parseFloat(retirementReturns[3]) || 0 },
          { asset: "other_retirement", return_percent: parseFloat(retirementReturns[4]) || 0 },
          { asset: "mf", return_percent: parseFloat(liquidReturns[0]) || 0 },
          { asset: "stocks", return_percent: parseFloat(liquidReturns[1]) || 0 },
          { asset: "bonds", return_percent: parseFloat(liquidReturns[2]) || 0 },
          { asset: "fdrd", return_percent: parseFloat(liquidReturns[3]) || 0 },
          { asset: "other_liquid", return_percent: parseFloat(liquidReturns[4]) || 0 }
        ],
        total_holding: stringToNum(totalHolding),
        total_monthly: stringToNum(totalContribution),
        capital_receipts: capitalReceipts.map(r => ({
          description: r.CRName,
          year: r.CRYear,
          amount: Number(String(r.CRAmt || '').replace(/,/g, '')) || 0,
          CRName: r.CRName,
          CRYear: r.CRYear,
          CRAmt: r.CRAmt
        })),
        annual_increase: stringToNum(annualIncrease),                    //updatedd
        retirement_returns: retirementReturns,
        liquid_returns: liquidReturns,
        goals: existingGoals,
        insurance_coverage: existingInsurance,
        liabilities_loans: existingLiabilities
      }
      localStorage.setItem('clientInvestmentData', JSON.stringify(userData));
      localStorage.setItem('versions', processString(localStorage.getItem('plan_id')));
      setData(userData)
      console.log(userData);
      const localtoken = localStorage.getItem("ssotoken");

      //Api call to save client investment details and generate pdf
      const result = await prpHttpAPI(userData, 'client-investment-details', localtoken, "POST")
      if (result.success) {

        console.log("client-investment-details Response:  ", result);

        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate('/insurance-loans', { state: { from: "clientInvestment" } })

        // let pdfResult = await getPdfURL();
        // console.log("get-pdf/pdf Response:  ", pdfResult);

        // if (!pdfResult.success) {
        //   console.log('pdf url is empty');
        //   return;

        // }
        // else {
        //   setLoading(false);
        //   donwloadPDF(pdfResult.url);
        //   setDownloadFlag(true);

        // }
      }
    } catch (error) {
      console.log("There is some error after api fetch ", error.message);
    }

  }
  const handleBack = () => {
    if (Number(annualIncrease) > annualIncreaseCap) {
      alert(`Max allowed: ${annualIncreaseCap}% (= min of 70% of income growth rate, Retirement Return & Liquid Return)`);
      return;
    }

    const postRetRorVal = Number(progressValuePost) || 0;
    const inflation = Number(inflationRateClientDetails) || 6;
    if (postRetRorVal < inflation) {
      alert("Post-retirement rate should not be less than inflation rate");
      setProgressValuePost(Number((inflation + 0.001).toFixed(3)));
      return;
    }

    let resolvedPostRetRor = postRetRorVal;
    if (postRetRorVal === inflation) {
      resolvedPostRetRor = Number((inflation + 0.001).toFixed(3));
      setProgressValuePost(resolvedPostRetRor);
    }

    const savedData = localStorage.getItem('clientInvestmentData');
    let existingGoals = [];
    let existingInsurance = [];
    let existingLiabilities = [];
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        existingGoals = parsed.goals || [];
        existingInsurance = parsed.insurance_coverage || [];
        existingLiabilities = parsed.liabilities_loans || [];
      } catch (e) {
        console.error("Error parsing existing goals", e);
      }
    }

    const clientInvestmentData = {
      plan_id: plan_id,
      epf_holding: stringToNum(epfHolding),
      epf_monthly: stringToNum(epfContribution),
      vpf_holding: stringToNum(vpfHolding),                     //updatedd
      vpf_monthly: stringToNum(vpfContribution),                //updatedd
      ppf_holding: stringToNum(ppfHolding),
      ppf_monthly: stringToNum(ppfContribution),
      nps_holding: stringToNum(npsHolding),
      nps_monthly: stringToNum(npsContribution),
      other_retirement_investment_holding: stringToNum(retHolding),
      other_retirement_investment_monthly: stringToNum(retContribution),
      mf_holding: stringToNum(mfHolding),
      mf_monthly: stringToNum(mfContribution),
      stocks_holding: stringToNum(stocksHolding),
      stocks_monthly: stringToNum(stocksContribution),
      bonds_holding: stringToNum(bondsHolding),
      bonds_monthly: stringToNum(bondsContribution),
      fdrd_holding: stringToNum(fdHolding),
      fdrd_monthly: stringToNum(fdContribution),
      other_non_retirement_investment_holding: stringToNum(nonRetHolding),
      other_non_retirement_investment_monthly: stringToNum(nonRetContribution),
      post_ret_ror: resolvedPostRetRor,
      pre_ret_ror: (progressValuePre),
      return_percent: [
        { asset: "epf", return_percent: parseFloat(retirementReturns[0]) || 0 },
        { asset: "ppf", return_percent: parseFloat(retirementReturns[1]) || 0 },
        { asset: "vpf", return_percent: parseFloat(retirementReturns[2]) || 0 },
        { asset: "nps", return_percent: parseFloat(retirementReturns[3]) || 0 },
        { asset: "other_retirement", return_percent: parseFloat(retirementReturns[4]) || 0 },
        { asset: "mf", return_percent: parseFloat(liquidReturns[0]) || 0 },
        { asset: "stocks", return_percent: parseFloat(liquidReturns[1]) || 0 },
        { asset: "bonds", return_percent: parseFloat(liquidReturns[2]) || 0 },
        { asset: "fdrd", return_percent: parseFloat(liquidReturns[3]) || 0 },
        { asset: "other_liquid", return_percent: parseFloat(liquidReturns[4]) || 0 }
      ],
      total_holding: stringToNum(totalHolding),
      total_monthly: stringToNum(totalContribution),
      capital_receipts: capitalReceipts.map(r => ({
        description: r.CRName,
        year: r.CRYear,
        amount: Number(String(r.CRAmt || '').replace(/,/g, '')) || 0,
        CRName: r.CRName,
        CRYear: r.CRYear,
        CRAmt: r.CRAmt
      })),
      annual_increase: stringToNum(annualIncrease),              //updatedd
      retirement_returns: retirementReturns,
      liquid_returns: liquidReturns,
      goals: existingGoals,
      insurance_coverage: existingInsurance,
      liabilities_loans: existingLiabilities
    }
    localStorage.setItem('clientInvestmentData', JSON.stringify(clientInvestmentData));
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/client-details')
  }


  const getInvestmentCategory = () => {
    const lowRisk =
      Number(numericEpfHolding || 0) + Number(numericEpfContribution || 0) +
      Number(numericPpfHolding || 0) + Number(numericPpfContribution || 0) +
      Number(numericBondsHolding || 0) + Number(numericBondsContribution || 0) +
      Number(numericFdHolding || 0) + Number(numericFdContribution || 0) +
      Number(numericVpfHolding || 0) + Number(numericVpfContribution || 0);

    const highRisk =
      Number(numericNpsHolding || 0) + Number(numericNpsContribution || 0) +
      Number(numericMfHolding || 0) + Number(numericMfContribution || 0) +
      Number(numericStocksHolding || 0) + Number(numericStocksContribution || 0) +
      Number(numericRetHolding || 0) + Number(numericRetContribution || 0) +
      Number(numericNonRetHolding || 0) + Number(numericNonRetContribution || 0);

    if (lowRisk > 0 && highRisk === 0) return "LOW_ONLY";
    if (highRisk > 0 && lowRisk === 0) return "HIGH_ONLY";
    if (lowRisk > 0 && highRisk > 0) return "MIXED";
    return "NONE";
  };

  const lowRiskHold =
    Number(numericEpfHolding || 0) + Number(numericEpfContribution || 0) +
    Number(numericPpfHolding || 0) + Number(numericPpfContribution || 0) +
    Number(numericBondsHolding || 0) + Number(numericBondsContribution || 0) +
    Number(numericFdHolding || 0) + Number(numericFdContribution || 0) +
    Number(numericVpfHolding || 0) + Number(numericVpfContribution || 0);

  const highRiskHold =
    Number(numericNpsHolding || 0) + Number(numericNpsContribution || 0) +
    Number(numericMfHolding || 0) + Number(numericMfContribution || 0) +
    Number(numericStocksHolding || 0) + Number(numericStocksContribution || 0) +
    Number(numericRetHolding || 0) + Number(numericRetContribution || 0) +
    Number(numericNonRetHolding || 0) + Number(numericNonRetContribution || 0);

  const totalHoldVal = lowRiskHold + highRiskHold;
  const highRiskPercent = totalHoldVal > 0 ? (highRiskHold / totalHoldVal) * 100 : 50;
  const lowRiskPercent = totalHoldVal > 0 ? (lowRiskHold / totalHoldVal) * 100 : 50;

  // SVG Doughnut Chart Calculations
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const highRiskOffset = circumference - (highRiskPercent / 100) * circumference;
  const lowRiskOffset = circumference - (lowRiskPercent / 100) * circumference;

  // const validatePreRetirementReturn = () => {
  //   const category = getInvestmentCategory();

  //   if (category === "LOW_ONLY" && progressValuePre > 8) {
  //     alert("Max allowed pre-retirement return is 8% for EPF / PPF / FD / Bonds");
  //     setProgressValuePre(8);
  //     setProgressValuePost(6);
  //     return false;
  //   }

  //   if (category === "HIGH_ONLY" && progressValuePre > 12) {
  //     alert("Max allowed pre-retirement return is 12% for MF / Stocks / NPS / Others");
  //     setProgressValuePre(12);
  //     setProgressValuePost(10);
  //     return false;
  //   }

  //   if (category === "MIXED" && progressValuePre > 10) {
  //     alert("Max allowed pre-retirement return is 10% for mixed portfolios");
  //     setProgressValuePre(10);
  //     setProgressValuePost(8);
  //     return false;
  //   }

  //   return true;
  // };


  return (
    <div className={styles.topMain}>
      <PageTracker currentStep={2} />
      <div className={styles.main}>
        <div className={styles.masterCard}>
          <div className={styles.cardHeaderOuter}>
            {/* <div className={styles.redLine} style={{ width: '4px', height: '24px', backgroundColor: 'black', marginRight: '12px', borderRadius: '2px' }}></div> */}
            <h1 className={styles.heading}>
              Client Investments
              <span className={styles.highlighted}>Retirement | Liquid / Non-Retirement</span>
            </h1>
          </div>

          <div className={styles.mainDiv}>
            {/* Retirement Investments Card */}
            <div className={`${styles.card} ${styles.cardRetirement}`}>
              <div className={styles.cardHeader}>
                <span className={`${styles.cardTitle} ${styles.cardTitleRetirement}`}>🔴 Retirement Investments</span>
              </div>
              <div className={styles.cardBody}>
                <div className={styles.tableHeader}>
                  <span>INSTRUMENT</span>
                  <span>MONTHLY (₹)</span>
                  <span>HOLDING (₹)</span>
                  <span>RETURN %</span>
                  <span></span>
                </div>

                {[
                  { value: epfHolding, onChange: handleEpfHolding, monthly: epfContribution, onMonthlyChange: handleEpfContribution, returnRate: retirementReturns[0], onReturnChange: (e) => updateRetirementReturn(0, e.target.value) },
                  { value: ppfHolding, onChange: handlePpfHolding, monthly: ppfContribution, onMonthlyChange: handlePpfContribution, returnRate: retirementReturns[1], onReturnChange: (e) => updateRetirementReturn(1, e.target.value) },
                  { value: vpfHolding, onChange: handleVpfHolding, monthly: vpfContribution, onMonthlyChange: handleVpfContribution, returnRate: retirementReturns[2], onReturnChange: (e) => updateRetirementReturn(2, e.target.value) },
                  { value: npsHolding, onChange: handleNpsHolding, monthly: npsContribution, onMonthlyChange: handleNpsContribution, returnRate: retirementReturns[3], onReturnChange: (e) => updateRetirementReturn(3, e.target.value) },
                  { value: retHolding, onChange: handleRetHolding, monthly: retContribution, onMonthlyChange: handleRetContribution, returnRate: retirementReturns[4], onReturnChange: (e) => updateRetirementReturn(4, e.target.value) },
                ].map((item, idx) => visibleRetirementRows.includes(idx) && (
                  <React.Fragment key={idx}>
                    <div className={styles.instrumentRow}>
                      <input
                        type="text"
                        value={retirementLabels[idx]}
                        onChange={(e) => updateRetirementLabel(idx, e.target.value)}
                        className={styles.instrumentName}
                         readOnly
                      />
                      <div className={styles.inputWrapper}>
                        <input type="text" value={item.monthly} onChange={item.onMonthlyChange} placeholder="Monthly" className={styles.inputField} />
                      </div>
                      <div className={styles.inputWrapper}>
                        <input type="text" value={item.value} onChange={item.onChange} placeholder="Amount" className={styles.inputField} />
                      </div>
                      <div className={styles.returnWrapper}>
                        {idx < 3 ? (
                          <div className={styles.lockedReturnWrapper}>
                            <span>{item.returnRate}%</span>
                            <span className={styles.lockIconMini}>🔒</span>
                          </div>
                        ) : (
                          <>
                            <select
                              value={item.returnRate}
                              onChange={item.onReturnChange}
                              className={styles.dropdownField}
                            >
                              {[6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 12, 13, 14, 15].map(val => (
                                <option key={val} value={val}>{val}%</option>
                              ))}
                            </select>
                            {idx === 3 && (
                              <button
                                type="button"
                                onClick={() => setNpsInfoOpen(prev => !prev)}
                                aria-label="Return rate info"
                                className={styles.infoIconBlue}
                                style={{
                                  marginLeft: '6px',
                                  cursor: 'pointer',
                                  border: 'none',
                                  padding: 0,
                                }}
                              >
                                i
                              </button>
                            )}
                          </>
                        )}
                      </div>
                      {/* <button onClick={() => removeRetirementRow(idx)} className={styles.removeBtn}>×</button> */}
                    </div>
                    {idx === 3 && npsInfoOpen && (
                      <div style={{
                        margin: '-6px 0 10px 1.5rem',
                        fontSize: '0.78rem',
                        fontWeight: '600',
                        color: '#dc2626',
                        letterSpacing: '0.01em',
                      }}>
                        Select Market-linked returns based on your asset allocation
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
              {/* <button onClick={addRetirementRow} className={styles.addBtn} style={{ margin: '0 1.5rem 1rem', width: 'auto' }}>
                + Add Investment
              </button> */}
              <div className={styles.cardFooter}>
                <span className={styles.totalLabel}>Total Retirement</span>
                <div className={styles.totalValueGroup}>
                  Monthly: <span>₹ {totalRetirementMonthly || 0}</span> Holding: <span>₹ {totalRetirementHolding || 0}</span>
                </div>
              </div>
            </div>

            {/* Liquid Investments Card */}
            <div className={`${styles.card} ${styles.cardLiquid}`}>
              <div className={styles.cardHeader}>
                <span className={`${styles.cardTitle} ${styles.cardTitleLiquid}`}>🔵 Liquid / Non-Retirement</span>
              </div>
              <div className={styles.cardBody}>
                <div className={styles.tableHeader}>
                  <span>INSTRUMENT</span>
                  <span>MONTHLY (₹)</span>
                  <span>HOLDING (₹)</span>
                  <span>RETURN %</span>
                  <span></span>
                </div>

                {[
                  { value: mfHolding, onChange: handleMfHolding, monthly: mfContribution, onMonthlyChange: handleMfContribution, returnRate: liquidReturns[0], onReturnChange: (e) => updateLiquidReturn(0, e.target.value) },
                  { value: stocksHolding, onChange: handleStocksHolding, monthly: stocksContribution, onMonthlyChange: handleStocksContribution, returnRate: liquidReturns[1], onReturnChange: (e) => updateLiquidReturn(1, e.target.value) },
                  { value: bondsHolding, onChange: handleBondsHolding, monthly: bondsContribution, onMonthlyChange: handleBondsContribution, returnRate: liquidReturns[2], onReturnChange: (e) => updateLiquidReturn(2, e.target.value) },
                  { value: fdHolding, onChange: handleFdHolding, monthly: fdContribution, onMonthlyChange: handleFdContribution, returnRate: liquidReturns[3], onReturnChange: (e) => updateLiquidReturn(3, e.target.value) },
                  { value: nonRetHolding, onChange: handleNonRetHolding, monthly: nonRetContribution, onMonthlyChange: handleNonRetContribution, returnRate: liquidReturns[4], onReturnChange: (e) => updateLiquidReturn(4, e.target.value) },
                ].map((item, idx) => visibleLiquidRows.includes(idx) && (
                  <div key={idx} className={styles.instrumentRow}>
                    <input
                      type="text"
                      value={liquidLabels[idx]}
                      onChange={(e) => updateLiquidLabel(idx, e.target.value)}
                      className={styles.instrumentName}
                      readOnly
                    />
                    <div className={styles.inputWrapper}>
                      <input type="text" value={item.monthly} onChange={item.onMonthlyChange} placeholder="Monthly" className={styles.inputField} />
                    </div>
                    <div className={styles.inputWrapper}>
                      <input type="text" value={item.value} onChange={item.onChange} placeholder="Amount" className={styles.inputField} />
                    </div>
                    <div className={styles.returnWrapper}>
                      <select
                        value={item.returnRate}
                        onChange={item.onReturnChange}
                        className={styles.dropdownField}
                      >
                        {[6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 12, 13, 14, 15].map(val => (
                          <option key={val} value={val}>{val}%</option>
                        ))}
                      </select>
                    </div>
                    {/* <button onClick={() => removeLiquidRow(idx)} className={styles.removeBtn}>×</button> */}
                  </div>
                ))}
              </div>
              {/* <button onClick={addLiquidRow} className={styles.addBtn} style={{ margin: '0 1.5rem 1rem', width: 'auto' }}>
                + Add Investment
              </button> */}
              <div className={styles.cardFooter}>
                <span className={styles.totalLabel}>Total Liquid</span>
                <div className={styles.totalValueGroup}>
                  Monthly: <span>₹ {totalLiquidMonthly || 0}</span> Holding: <span>₹ {totalLiquidHolding || 0}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Control Bar for Returns and Annual Increase */}
          <div className={styles.controlBar}>
            {/* Row 1: Retirement Weighted, Liquid Weighted, Post-Retirement Return */}
            <div className={styles.controlBarRow}>
              <div className={styles.controlGroup}>
                <span className={styles.controlLabel}>
                  Retirement Instruments Return
                  {/* <span className={styles.infoIconBlue}>?</span> */}
                </span>
                <div className={styles.weightedBadgeRetirement}>
                  {retirementWeightedReturn}%
                </div>
                <span className={styles.weightedLabel}>
                  weighted <span className={styles.lockIcon}>🔒</span>
                </span>
              </div>

              <div className={styles.controlGroup}>
                <span className={styles.controlLabel}>
                  Liquid Instruments Return
                  {/* <span className={styles.infoIconBlue}>?</span> */}
                </span>
                <div className={styles.weightedBadgeLiquid}>
                  {liquidWeightedReturn}%
                </div>
                <span className={styles.weightedLabel}>
                  weighted <span className={styles.lockIcon}>🔒</span>
                </span>
              </div>

              <div className={styles.controlGroup}>
                <span className={styles.controlLabel}>Post-Retirement Return:</span>
                <div className={styles.customStepperWrapper}>
                  <input
                    type="number"
                    step={0.5}
                    min={0}
                    max={10}
                    value={progressValuePost}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      if (!isNaN(val)) setProgressValuePost(val);
                    }}
                    onBlur={handlePostInflationBlur}
                    className={styles.customStepperInput}
                  />
                  <div className={styles.customStepperButtons}>
                    <button
                      type="button"
                      onClick={() => {
                        setProgressValuePost(prev => {
                          const inflation = Number(inflationRateClientDetails) || 6;
                          // Current value may be inflation+0.001 (decimal), step up from there
                          const current = Number(prev) || 0;
                          // If current is the special decimal value, round up to next 0.5 step above inflation
                          const nextVal = current === inflation
                            ? Math.ceil((inflation + 0.5) * 2) / 2
                            : Number((current + 0.5).toFixed(1));
                          if (nextVal > 10) return 10;
                          return nextVal;
                        });
                      }}
                      className={styles.customStepperBtn}
                    >
                      ▲
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setProgressValuePost(prev => {
                          const inflation = Number(inflationRateClientDetails) || 6;
                          const current = Number(prev) || 0;
                          const nextVal = Number((current - 0.5).toFixed(1));
                          if (nextVal < inflation) {
                            // Going below inflation → alert, stay at inflation+0.001
                            alert("Post-retirement rate should not be less than inflation rate");
                            return Number((inflation + 0.001).toFixed(3));
                          }
                          if (nextVal === inflation) {
                            // Landing exactly on inflation → silently set to inflation+0.001
                            return Number((inflation + 0.001).toFixed(3));
                          }
                          return nextVal;
                        });
                      }}
                      className={styles.customStepperBtn}
                    >
                      ▼
                    </button>
                  </div>
                </div>
                <span className={styles.percentSign}>%</span>
              </div>
            </div>

            {/* Row 2: Annual Increase in Existing Investments */}
            <div className={styles.controlBarRow}>
              <div className={styles.controlGroup}>
                <span className={styles.controlLabel}>
                  Annual Increase in Existing Investments
                  {/* <span className={styles.infoIconBlue}>?</span> */}
                </span>
                <select
                  value={annualIncrease}
                  onChange={(e) => {
                    const selected = Number(e.target.value);
                    if (selected > annualIncreaseCap) {
                      alert(`Maximum Allowed: ${annualIncreaseCap}% = Lowest of: 70% × Income Growth | Retirement Wtd. Avg. Return | Liquid Wtd. Avg. Return`);
                      // Reset dropdown back to the last valid value (do not update state)
                      e.target.value = annualIncrease;
                      return;
                    }
                    setAnnualIncrease(e.target.value);
                  }}
                  className={styles.selectField}
                >
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((val) => (
                    <option key={val} value={val}>
                      {val}%
                    </option>
                  ))}
                </select>
                <span className={styles.paText}>p.a.</span>
              </div>
            </div>
          </div>
        </div>

        {/* Capital Receipts Section */}
        <div className={styles.card} style={{ borderTop: "4px solid #4a4a4a", marginBottom: "2rem" }}>
          <div className={styles.cardHeaderOuter} style={{ padding: '1rem 1.5rem', marginBottom: '0' }}>
            {/* <div className={styles.redLine} style={{ width: '4px', height: '24px', backgroundColor: '#4a4a4a', marginRight: '12px', borderRadius: '2px' }}></div> */}
            <div>
              <h2 className={styles.heading}>Capital Receipts</h2><br />
              <span className={styles.sectionSubtitle}>One-time Inflows</span>
            </div>
          </div>
          <div className={styles.cardBody}>
            <p className={styles.sectionDesc}>
              Please enter one time future inflows like Gratuity, Property sale, etc here.
            </p>

            {capitalReceipts.length > 0 ? (
              <div className={styles.capitalTable}>
                <div className={styles.tableHead}>
                  <span>Description</span>
                  <span>Year of Receipt</span>
                  <span>Amount</span>
                  <span></span>
                </div>
                {capitalReceipts.map((receipt, index) => (
                  <div key={index} className={styles.tableRow}>
                    <input
                      type="text"
                      placeholder="e.g. Gratuity"
                      value={receipt.CRName}
                      onChange={(e) => updateCapitalReceipt(index, "CRName", e.target.value)}
                      className={styles.inputField}
                      style={{ textAlign: "left", paddingLeft: "1rem", color: "#333", borderColor: "#e0e0e0", backgroundColor: "#fff" }}
                    />
                    <input
                      type="number"
                      placeholder="Year"
                      value={receipt.CRYear}
                      onChange={(e) => updateCapitalReceipt(index, "CRYear", e.target.value)}
                      className={styles.inputField}
                      style={{ color: "#333", borderColor: "#e0e0e0", backgroundColor: "#fff" }}
                    />
                    <div className={styles.inputWrapper}>
                      <input
                        type="text"
                        placeholder="Amount"
                        value={receipt.CRAmt}
                        onChange={(e) => updateCapitalReceipt(index, "CRAmt", e.target.value)}
                        className={styles.inputField}
                        style={{ color: "#333", borderColor: "#e0e0e0", backgroundColor: "#fff" }}
                      />
                    </div>
                    <button onClick={() => removeCapitalReceipt(index)} className={styles.removeBtn}>×</button>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.noData}>No Capital Receipts Added.</div>
            )}

            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <button onClick={addCapitalReceipt} className={styles.addBtn}>
                + Add Capital Receipts
              </button>
              <button onClick={handleSaveCapitalReceipts} className={styles.addBtn}>
                Save Capital Receipts
              </button>
            </div>

            {showSavedMessage && (
              <div style={{ marginTop: '1rem', padding: '0.75rem', backgroundColor: '#e8f5e9', color: '#1b5e20', border: '1px solid #c8e6c9', borderRadius: '4px', fontWeight: 'bold' }}>
                Capital Receipts saved!
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className={styles.footerDivider}></div>
        <div className={styles.loaderGroup}>
          <div className={styles.btnGroup}>
            <button onClick={handleBack} className={styles.backBtn} disabled={loading}>
              Back
            </button>
            <button onClick={handlePreparePlan} className={styles.nextBtn} disabled={loading}>
              Next — Protection & Liabilities <span className={styles.arrowIcon}>→</span>
            </button>
          </div>
          <div className={styles.loaderContainer}>
            {loading && (
              <div className="spinner-border spinner-border-sm text-danger" role="status">
                <span className="sr-only"></span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}



